import { Navigate, Outlet, useLocation } from "react-router-dom";
import authManager from "../services/auth/AuthManager";

const DefaultLayout = () => {
  const location = useLocation();
  console.log(location.pathname);
  const isLoggedIn = authManager.isLoggedIn();

  console.log("isLoggedIn", isLoggedIn);
  if (
    (location.pathname === "/login" || location.pathname === "/") &&
    isLoggedIn
  ) {
    return <Navigate to="/admin/dashboard" replace={true} />;
  } else {
    return (
      <div className="layout">
        <Outlet />
      </div>
    );
  }
};

export default DefaultLayout;
